import React, { useEffect, useState } from 'react';
import MainFrame from './component/MainUIFrame/MainFrame';
import NVBackdrop from './component/reusableUiComponent/NVBackdrop';
import { ErrorBoundary } from 'react-error-boundary';
import AlertPopUp from './component/Popup/AlertPopup';
import RootRouter from 'routes/Routes';
import DisconnectedDialog from 'component/dialogs/DisconnectedDialog';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth, onAuthStateChanged, signOut } from './firebase';
import { setUserLanguage, setUserTheme, setLoggedInUserData, setUserSettingResponse, setIsAdmin, setIsLoggedInAsAdmin } from 'redux/features/currentUserSlice';
import { useDispatch } from 'react-redux';
import { ehrAPIBaseService, ehrAPIService } from 'adapters/http-common';
import dayjs from 'dayjs';
// import { useSelector } from 'react-redux';
// import { setProgress } from 'redux/features/progressSlice';
import i18n from 'multilingual';
import { GET_DEPARTMENTS_AND_CREDENTIALS, GET_DEPARTMENTS_AND_CREDENTIALS_AT_LOGIN } from 'adapters/mmprh.service';
import { setAllRoles, setCredentials, setDepartments } from 'redux/features/configSlice';
import FallBackLoader from 'component/ui/loader/FallbackLoader';
import { flatMap } from 'lodash';
import jwtDecode from 'jwt-decode';
import IdleController from 'component/idleTimer/IdleController';
import { toast } from 'react-toastify';

function App() {

  const reduxDispatch = useDispatch();
  const [networkStatus, setNetworkStatus] = useState(true);
  const [mainLoader, setMainLoader] = useState(true);
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [isFirebaseLoaded, setIsFirebaseLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  // const { theme, language } = useSelector(state => state?.currentUser)

  // const loggedInUserData = useSelector(state => state?.currentUser?.loggedInUserData)

  const broadcastChannel = new BroadcastChannel('authChannel');
  broadcastChannel.addEventListener('message', event => {
    if (event.data.type === 'logout') {
      navigate('/login');
    }
  });

  const channel = new BroadcastChannel('user-login-channel');
  channel.onmessage = event => {
    if (event.data.type === 'user-login') {
      window.location.reload();
    }
  };

  useEffect(async () => {
    // reduxDispatch(setProgress(true));
    // setMainLoader(true)
    const unsubscribe = onAuthStateChanged(auth, user => {
      console.log(`Auth state changed`, user, auth);
      if (user) {
        setMainLoader(true)
        // if (user?.reloadUserInfo?.customAttributes?.includes('portal_user')) {
        //   setOpen(true);
        //   handleLogout();
        //   reduxDispatch(setProgress(false));

        //   return false;
        // }
        reduxDispatch(setLoggedInUserData(user));

        setFirebaseUser(user);
        user
          ?.getIdToken()
          ?.then(async (token) => {
            localStorage.setItem(`jwtToken`, token);
            localStorage.setItem(`username`, user?.displayName);
            localStorage.setItem(`loginAt`, user?.metadata?.lastSignInTime);
            setIsFirebaseLoaded(true);
            let jwtToken = jwtDecode(token);
            jwtToken = jwtToken?.firebase?.tenant;
            const data = await GET_DEPARTMENTS_AND_CREDENTIALS_AT_LOGIN(jwtToken);
            const allRoles = flatMap(data?.MMPRH_department?.map(item => item?.roles))
            let personDetail = await ehrAPIBaseService.get(
              '/fhir/search/?resourceType=Person&identifier=http://enliv.com/user/firebase-uid|' +
              user?.uid
            );
            let role = JSON?.parse(personDetail?.data?.entry[0]?.resource?.extension?.find(item => item?.url == "http://enliv.com/extensions/user/custom-claims")?.valueString)?.mmprh?.roles?.[0]
            // const isAdmin = allRoles?.find(item => item?.id == role)?.is_admin
            const isAdmin = JSON.parse(personDetail?.data?.entry?.[0]?.resource?.extension?.find(f=>f?.url==="http://enliv.com/extensions/user/custom-claims")?.valueString)?.mmprh?.is_admin
            reduxDispatch(setDepartments(data?.MMPRH_department || []))
            reduxDispatch(setCredentials(data?.MMPRH_credential || []))
            reduxDispatch(setAllRoles(allRoles || []))
            reduxDispatch(setIsAdmin(Boolean(isAdmin) || false))
            if(Boolean(isAdmin) && localStorage.getItem('isLoggedInAsAdmin') === null){
              localStorage.setItem(`isLoggedInAsAdmin`, true);
              reduxDispatch(setIsLoggedInAsAdmin(true));
            }else{
              if(localStorage.getItem('isLoggedInAsAdmin') === 'false'){
                reduxDispatch(setIsLoggedInAsAdmin(false));
              }
            }

          })
          .catch(error => {
            console.log(`firebase auth error`, error);
            setFirebaseUser(null);
            setIsFirebaseLoaded(true);
          });
      } else {
        setFirebaseUser(null);
        setIsFirebaseLoaded(true);
      }
    });
    // reduxDispatch(setProgress(false));
    // setMainLoader(false)

    // fetching the config data
    // const data = await GET_DEPARTMENTS_AND_CREDENTIALS()
    // reduxDispatch(setDepartments(data?.MMPRH_department || []))
    // reduxDispatch(setCredentials(data?.MMPRH_credential || []))

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    refreshUserData(firebaseUser, isFirebaseLoaded);
  }, [firebaseUser, isFirebaseLoaded]);

  const createUserSetting = async userId => {
    let setting = {
      theme: 'light',
      language: 'en',
    };
    let payload = {
      resourceType: 'Basic',
      code: {
        coding: [
          {
            system: 'http://enliv.com/code/basic-resource-type',
            code: 'user.preference.ui',
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format('YYYY-MM-DD'),
      extension: [
        {
          url: 'http://enliv.com/settings/data',
          valueString: JSON.stringify(setting),
        },
      ],
    };

    const response = await ehrAPIService.post(`createResource`, payload);
    return response;
  };

  const getLoggedInUserData = async uid => {
    // setMainLoader(true)
    try {
      let personDetail = await ehrAPIBaseService.get(
        '/fhir/search/?resourceType=Person&identifier=http://enliv.com/user/firebase-uid|' +
        uid
      );
      if (personDetail?.data?.entry?.[0]?.resource?.id) {
        let personId = personDetail?.data?.entry?.[0]?.resource?.id;
        let UserSetting = await ehrAPIBaseService.get(
          `fhir/search/?resourceType=Basic&code=user.preference.ui&subject=Person/${personId}`
        );

        if (UserSetting?.data?.total) {
          const rawData = { ...UserSetting?.data?.entry?.[0]?.resource };
          const displaySetting = rawData?.extension?.find(
            item => item?.url === 'http://enliv.com/settings/data'
          )?.valueString;
          if (displaySetting) {
            reduxDispatch(
              setUserLanguage(
                JSON?.parse(displaySetting)?.language,
              )
            );
            i18n.changeLanguage(JSON?.parse(displaySetting)?.language)
            reduxDispatch(
              setUserTheme(
                JSON?.parse(displaySetting)?.theme,
              )
            );
            reduxDispatch(
              setUserSettingResponse({
                ...rawData
              })
            );

          }
        } else {
          const responseSetting = await createUserSetting(personId);
          if (responseSetting) {
            reduxDispatch(
              setUserLanguage(
                JSON?.parse(responseSetting?.data?.extension?.[0]?.valueString)?.language,
              )
            );
            i18n.changeLanguage(JSON?.parse(responseSetting?.data?.extension?.[0]?.valueString)?.language)
            reduxDispatch(
              setUserTheme(
                JSON?.parse(responseSetting?.data?.extension?.[0]?.valueString)?.theme,
              )
            );
            reduxDispatch(
              setUserSettingResponse({
                ...responseSetting?.data
              })
            );
          }
        }
      }

    } catch (e) {
      console.error(e);
    } finally {
      // reduxDispatch(setProgress(false));
      // setMainLoader(false)
      return true
    }
  };

  const refreshUserData = (firebaseUser, isFirebaseLoaded) => {

    const currentLocation = location?.pathname;
    setMainLoader(true)
    if (isFirebaseLoaded) {
      if (firebaseUser) {
        // reduxDispatch(setProgress(true));
        getLoggedInUserData(firebaseUser?.uid)
          .then(() => {
            setMainLoader(false);
            if (currentLocation === '/login' || currentLocation === '/' || currentLocation === '') {
              navigate(`/home/dashboard`, { replace: true });
            }
          })
        // reduxDispatch(setProgress(false));
      } else {
        setMainLoader(false)
        // reduxDispatch(clearLoggedInUserData());
        // if (currentLocation !== '/login') {
        //   navigate('/login', { replace: true });
        // }
      }
    }
  };

  const handleLogout = () => {
    signOut(auth)
      ?.then(() => {
        console.log(`signout successfull`);
        window.location.href = '/login';
        localStorage?.clear();
        // navigate('/login', { replace: true });
        // if(firebaseUser){
        //   toast.info('You have been logged out, due to inactivity of 3 minutes!',{autoClose:false,position: "top-center"})
        // }
        setFirebaseUser(null);
        setIsFirebaseLoaded(true);
      })
      .catch(e => {
        console.log(`some issue in firebase signout`, e);
      });
  };


  return (
    <>
    <IdleController handleLogout={handleLogout} />
      <DisconnectedDialog />
      <AlertPopUp open={open} setOpen={setOpen} />
      <>
        <NVBackdrop />
        {/* <MainFrame firebaseUser={firebaseUser} isOnline={networkStatus}> */}
        {mainLoader ? <>
          <FallBackLoader />
        {/* </> : <MainFrame firebaseUser={true} isOnline={networkStatus}> */}
        </> : <MainFrame firebaseUser={firebaseUser} isOnline={networkStatus}>
          <RootRouter />
        </MainFrame>}
      </>
    </>
  );
}

export default App;
